import React from "react";
import { inject } from "mobx-react";

import HangtagComponent from "./HangtagComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { URL_APP_APP_BASE_PATH, PAGES_HANGTAGS_TAB, PREVIEW_TYPE, HIGHLIGHT_TYPE } from "~/configs/constants";
import { valueCurrencyToInt }  from "../../helpers/monetary"
import { isEmptyOrNullInt, isEmptyOrNullStr, getVarFromUrl } from "../../helpers/utils";

@inject("HangtagStore", "DeviceStore", "ProductStore", "PageStore", "PreviewStore")
class HangtagContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      hangtag: {},
      products:[],
    };
  }

  async componentDidMount() {
    await this.getHangtag();
  }

  getHangtag = async () => {
    this.setState({
      isLoading: true,
    });

    const { HangtagStore, PageStore, history } = this.props;
    const deviceId = getVarFromUrl("deviceId");
    const pageId = getVarFromUrl("pageId");
    const hangtagId = getVarFromUrl("hangtagId");
    
    const hasDevice = deviceId !== undefined && parseInt(deviceId) > 0;
    if(!hasDevice){
      history.push("/");
      return;
    }

    let hangtag = {};
    hangtag.deviceId = deviceId;
    hangtag.pageId = pageId;
    hangtag.highlightType = HIGHLIGHT_TYPE.none;
    if (hangtagId !== undefined && parseInt(hangtagId) > 0){
      hangtag = await HangtagStore.getHangtag(hangtagId);
    }   

    var page = await PageStore.getPage(pageId);
    let productResult = await this.getProduct(hangtag, deviceId);
    let product = productResult.product;
    let products = productResult.products;
  
    this.setState({
      hangtag,
      isLoading: false,
      page,     
      product,
      products
    });
  };

  makeProductItem = (product) => {
    return {
      id: product.productId,
      name: product.name + " " + product.code,
      label: product.name + " " + product.code,
      productId: product.productId,
      code: product.code,
      valueStr: product.valueStr,
      originalValueStr: product.originalValueStr,
      clubValueStr: product.clubValueStr,
      originalValue: product.originalValue,
      clubValue: product.clubValue,
      description: product.description,
      originalName: product.name,
      value: product.value,
      available: product.available,
      isFractioned: product.isFractioned,
      isOffer: product.isOffer,
      isClub: product.isClub
    };
  }

  getProduct = async (hangtag, deviceId) => {
    let products = await this.getProducts("", deviceId);
    let result = {};
    if (hangtag.product != null && hangtag.product.productId > 0)
      result.product = this.makeProductItem(hangtag.product);
    else 
      result.product = products[0];
    
    if (!this.isProductList(result.product, products))
      products.push(result.product);
    
    result.products = products;
    return result;
  }

  getProducts = async (filter, deviceId) => {
    if (filter === "Nenhum ") filter = "";
    const { ProductStore } = this.props
    let products = [];
    let productsData = await ProductStore.searchProductsByDevice(filter, deviceId);
    for(let i = 0; i < productsData.length; i++) {
      products.push(this.makeProductItem(productsData[i]));
    }
    return products;
  };

  goDevice = () => {
    const { history } = this.props;
    history.push(`page?deviceId=${getVarFromUrl("deviceId")}&pageId=${getVarFromUrl("pageId")}&tab=${PAGES_HANGTAGS_TAB}`);
  };

  maintainHangtag = async () => {
    this.setState({
      isLoading: true
    });

    const { hangtag } = this.state;
    const { HangtagStore } = this.props;

    if (isEmptyOrNullInt(hangtag.productId)) AlertComponent.error("Nenhum produto selecionado");
    else {
      hangtag.product.name = hangtag.product.originalName;
      const result = await HangtagStore.update(hangtag);
      if (result && result?.tagId > 0){
        AlertComponent.success("Etiqueta salva com sucesso");
        this.goDevice();
      } else {
        AlertComponent.error("Falha ao salvar etiqueta");
      }
    }

    this.setState({
      isLoading: false
    });
  };

  onChange = (e) => {
    const { hangtag } = this.state;
    const updatedHangtag = {
      ...hangtag,
      [e.target.name]: e.target.value
    }

    this.setState({
      hangtag: updatedHangtag,
    });
  };

  onChangeValue = (value) => {
    let { hangtag, product } = this.state;
    hangtag.product.valueStr = value;
    hangtag.product.value = valueCurrencyToInt(value);
    product.valueStr = hangtag.product.valueStr;
    product.value = hangtag.product.value;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };

  onChangeOriginalValue = (value) => {
    let { hangtag, product } = this.state;
    hangtag.product.originalValueStr = value;
    hangtag.product.originalValue = valueCurrencyToInt(value);
    product.originalValueStr = hangtag.product.originalValueStr;
    product.originalValue = hangtag.product.originalValue;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };

  onChangeClubValue = (value) => {
    let { hangtag, product } = this.state;
    hangtag.product.clubValueStr = value;
    hangtag.product.clubValue = valueCurrencyToInt(value);
    product.clubValueStr = hangtag.product.clubValueStr;
    product.clubValue = hangtag.product.clubValue;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  }; 

  onChangeName = (name) => {
    let { hangtag, product } = this.state;
    hangtag.product.name = name;
    hangtag.product.originalName = hangtag.product.name;
    product.name = hangtag.product.name;
    product.originalName = hangtag.product.name;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };  

  onChangeCode = (code) => {
    const { hangtag, product } = this.state;
    hangtag.product.code = code;
    product.code = hangtag.product.code;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };  

  onChangeIsFractioned = (value) => {
    let { hangtag, product } = this.state;
    hangtag.product.isFractioned = value;
    product.isFractioned = hangtag.product.isFractioned;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };
  
  onChangeDescription = (description) => {
    let { hangtag, product } = this.state;
    hangtag.product.description = description;
    product.description = hangtag.product.description;
    product.name = product.originalName;
    this.setState({
      hangtag,
      product: this.makeProductItem(product)
    });
  };  
 
  onInputChangeProduct = async (event, value) => {
    if (event !== null) {
      try { 
          if (event.type === "change") {
            this.setState({
              productIsLoading: true,
            });
            const { product } = this.state;
            let products = await this.getProducts(value, getVarFromUrl("deviceId"));
      
            if (!this.isProductList(product, products))
              products.push(product);
      
            this.setState({
              products,
              productIsLoading: false
            });
          }
          else {
            const { products, product } = this.state;
            let productSelected = product;
            for (var i = 0; i < products.length; i++){
              if (products[i].name === value){
                productSelected = products[i];
                break;
              }
            }
            this.onChangeProduct(productSelected);            
          }          
        }
      catch { }
    }
  };

  isProductList = (product, products) => {
    if (product === undefined || product === null || product.productId === undefined) return false;
    for (var i = 0; i < products.length; i++){
      if (products[i].productId === product.productId){
        return true;
      }
    }; 
    return false;
  };

  onChangeProduct = (product) => {
    const { hangtag } = this.state;
    let updatedHangtag = {
      ...hangtag,
      product,
      productId: product?.productId,
    }    
    if (product.isOffer) updatedHangtag.highlightType = HIGHLIGHT_TYPE.offer;
    else if (product.isClub) updatedHangtag.highlightType = HIGHLIGHT_TYPE.club;
    this.setState({
      hangtag: updatedHangtag,
      product: product
    });
  };

  preview = async () => {
    try {
      setTimeout(async() => {
        const iframe = document.getElementById("tagPreview");
        const fallback = document.getElementById("fallback");
        const loader = document.getElementById("loader");
        const { PreviewStore } = this.props;
        const deviceId = getVarFromUrl("deviceId");
        const pageId = getVarFromUrl("pageId");

        fallback.style.display = "none";
        loader.style.display = "flex";
        iframe.style.opacity = 0; 

        let preview = {};
        const hangtag = JSON.parse(JSON.stringify(this.state.hangtag)); 
        if (hangtag.product !== undefined && hangtag.product !== null) {
          hangtag.product.name = isEmptyOrNullStr(hangtag.product.originalName) ? hangtag.product.name : hangtag.product.originalName;
        }

        preview.payload = JSON.stringify(hangtag);
        preview.type = PREVIEW_TYPE.tag;
        preview.deviceId = deviceId;
        preview.pageId = pageId;
        preview = await PreviewStore.add(preview);
        
        const path = URL_APP_APP_BASE_PATH + "?preview=" + preview.previewId.toString();

        iframe.src = path;
        
        window.addEventListener("message", (event) => {
          if (event.data.msg === "PREVIEW_READY") {
            iframe.style.transition = "opacity 0.5s ease";
            iframe.style.opacity = 1;
            loader.style.display = "none";
            fallback.style.display = "none";
          }
        });
      }, 0);
    } catch {}  
  };

  render() {
    const { isLoading, hangtag, products, productIsLoading, product, page } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <div className="content content-xs">
            <HangtagComponent
              hangtag={hangtag}
              onClick={this.maintainHangtag}
              onCancel={this.goDevice}
              onChange={this.onChange}
              products={products}
              product={product}
              onInputChangeProduct={this.onInputChangeProduct}
              onChangeOriginalValue={this.onChangeOriginalValue}
              onChangeClubValue={this.onChangeClubValue}
              productIsLoading={productIsLoading}
              page={page}
              preview={this.preview}
              onChangeIsFractioned={this.onChangeIsFractioned}
              onChangeValue={this.onChangeValue}
              onChangeName={this.onChangeName}
              onChangeCode={this.onChangeCode}
              onChangeDescription={this.onChangeDescription}
            />
          </div>
        )}
      </>
    );
  }
}

export default HangtagContainer;
